export const setPermissionPopup = (payload) => ({
  type: "permissionDenyState",
  payload,
});
